<template>
  <div id="Global" @click.self="inputBlur">
    <div class="content-container">
      <div class="content-item">
        <h1 class="title">{{ $t('OVERSEAS.CARD_PAYMENT') }}</h1>
        <h3 class="sub-title">{{ $t('CARD_SELECTION.GUIDE_TEXT') }}</h3>
        <div class="input-container">

          <div class="input-box">
            <div class="input-title">카드 번호</div>
            <div class="input-wrap">
              <input type="tel" inputmode="numeric" class="input-item" placeholder="예) 1234 - 1234 - 1234 - 1234" v-model="card.number" @focus="focusInput" @blur="blurInput" ref="cardNumber">
            </div>
          </div>

          <div class="input-box">
            <div class="input-title">{{ $t('DOMESTIC.VALIDITY') }}</div>
            <div class="input-wrap">
              <input type="tel" inputmode="numeric" class="input-item card-validity" :style="styleObject" placeholder="MM / YY" ref="validityDate" v-model="card.validity" maxlength="4"  @focus="focusInput" @blur="blurInput">
              <div class="validity-date input-item" @click="$refs.validityDate.focus()"  :style="styleObject">
                <span class="date-number" :class="{ 'filled': card.validity[0], 'cursor': card.validity.length === 0 }">{{ card.validity[0] || 'M'}}</span>
                <span class="date-number" :class="{ 'filled': card.validity[1], 'cursor': card.validity.length === 1 }">{{ card.validity[1] || 'M'}}</span>
                <span> / </span>
                <span class="date-number" :class="{ 'filled': card.validity[2], 'cursor': card.validity.length === 2 }">{{ card.validity[2] || 'Y'}}</span>
                <span class="date-number" :class="{ 'filled': card.validity[3], 'cursor': card.validity.length === 3 }">{{ card.validity[3] || 'Y'}}</span>
              </div>
            </div>
          </div>

          <!-- <div class="input-box">
            <div class="input-title">CVV/CVC</div>
            <div class="input-wrap">
              <input type="tel" inputmode="numeric" class="input-item" v-model="card.security">
            </div>
            <div class="input-guide">
              카드 뒷변 서명란 또는 신용카드 번호 오른쪽 상단에 기재된 3자리 또는 4자리 숫자
            </div>
          </div> -->
        </div>
      </div>

      <div class="content-item">
        <h1 class="title">{{ $t('OVERSEAS.RECEIPT') }}</h1>
        <h2 class="guide">{{ $t('OVERSEAS.RECEIPT_SUB_TITLE') }}</h2>
        <div class="input-container">

          <div class="input-box">
            <div class="input-title">{{ $t('OVERSEAS.EMAIL_ADDRESS') }}</div>
            <div class="input-wrap">
              <input type="tel" inputmode="numeric" class="input-item"  @focus="focusInput" @blur="blurInput" ref="email">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="button-container">
      <button class="next-step" :class="{ 'hide': !visibleBtnNext }" :style="styleObject" @click="nextStep" :disabled="disBtnNext">{{ $t('COMMON.NEXT') }}</button>
    </div>
  </div>
</template> 

<script>
import vuex from 'vuex'

export default {
  data() {
    return {
      card: {
        number: '',
        validity: '',
        // number: '4171-0307-0763-3949',
        // validity: '0823',
        security: ''
      },
      disBtnNext: false,
      visibleBtnNext: true

    }
  },
  computed: {
    ...vuex.mapGetters({
      'getColor': 'style/getColor',
      'GET_PAYMENT_INFORMATION': 'GET_PAYMENT_INFORMATION',
      'GET_OVERSEAS_PAYMENT_TYPE': 'GET_OVERSEAS_PAYMENT_TYPE',
      'GET_PAYMENT_QUERY': 'GET_PAYMENT_QUERY'
    }),
    styleObject: function() {
      return {
        '--color': this.getColor.primaryColor,
        '--color-active': this.getColor.primaryColorDark
      }
    }
  },
  methods: {
    ...vuex.mapActions({
      'REQUEST_CARD_PAYMENT': 'REQUEST_CARD_PAYMENT',
      'SET_ERROR_PAGE': 'SET_ERROR_PAGE'
    }),
    async nextStep() {
      this.disBtnNext = true;
      let res = await this.requestCardPayment();

      console.log(res)
      if(res.data.success) {
        this.$router.push('/page/complete')
      } else {
        this.SET_ERROR_PAGE({
          message: res.data.error_message,
          code: res.data.error_code
        })
        this.$router.push('/page/failure')
      }

      this.disBtnNext = false;
    },
    async requestCardPayment() {
      let cardNumber = this.card.number;
      cardNumber = cardNumber.replace(/[^0-9]/g,'');   // 입력값이 숫자가 아니면 공백
      cardNumber = cardNumber.replace(/-/g,'');        // ,값 공백처리
      cardNumber = this.encrypt(cardNumber, this.GET_PAYMENT_QUERY.api_key);

      let cardValidity = this.card.validity;
      let validityMonth = cardValidity.substr(0, 2);
      let validityYear = cardValidity.substr(2, 2);
      cardValidity = this.encrypt(validityYear+validityMonth, this.GET_PAYMENT_QUERY.api_key);

      let card = {
        number: cardNumber,
        validity: cardValidity
      }

      let res = await this.REQUEST_CARD_PAYMENT({
        card: card
      })

      return res;
    },
    encrypt (text, key) {
      const iv = this.CryptoJS.lib.WordArray.random(16)
      const keyHash = this.CryptoJS.SHA256(key)
      const cipherText = this.CryptoJS.AES.encrypt(text, keyHash, { iv: iv } ).ciphertext
      
      return this.CryptoJS.enc.Hex.stringify(iv) + this.CryptoJS.enc.Hex.stringify(cipherText)
    },
    focusInput() {
      this.visibleBtnNext = false;
    },
    blurInput() {
      this.visibleBtnNext = true;
    },
    inputBlur() {
      console.log(this.$refs)

      for(let el in this.$refs) {
        console.log(el)
        this.$refs[el].blur();
      }

    }
  }
}
</script>

<style lang="scss">
@import './card.scss';

#Global {
  .input-wrap {
    position: relative;
  }

  .card-validity {
    position: absolute;
    // top: 28px;
    left: -2000px;
    height: 50px;

    color: transparent;

   &:focus ~ .validity-date {
      .cursor {
        animation: cursor-literals infinite 1s linear;        
      }
    }

    @keyframes cursor-literals {
      from {
        color: $color-black-30;
      }

      50% {
        color: var(--color);
      }

      to {
        color: $color-black-30;
      }
    }
  }

  .validity-date {
    line-height: 50px;

    .date-number {
      color: $color-black-30;
    }

    .filled {
      color: black;
    }

    
  }
}
</style>